import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './app';
import { InternalServerError } from 'shared/components';
import {BugsnagConfigProvider, ErrorBoundary} from '@dnhb/functional-component';

const apiKey = process.env.BUGSNAG_JS_API_KEY;

const Root = () => (
  <BugsnagConfigProvider bugsnagApiKey={apiKey}>
    <ErrorBoundary fallbackComponent={InternalServerError}>
      <Suspense fallback={null}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </Suspense>
    </ErrorBoundary>
  </BugsnagConfigProvider>
);

export default Root;
